import {
  ActionIcon,
  Anchor,
  Badge,
  Box,
  Button,
  FileButton,
  Flex,
  Grid,
  Menu,
  MultiSelect,
  MultiSelectProps,
  rem,
  Select,
  Switch,
  Table,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import { useForm } from "@mantine/form";
import { useDebouncedValue, useDisclosure } from "@mantine/hooks";
import {
  IconBoxSeam,
  IconBuilding,
  IconCheck,
  IconExternalLink,
  IconFileExport,
  IconFilter,
  IconListLetters,
  IconPhoto,
  IconPhotoDown,
  IconPhotoPlus,
  IconRefresh,
  IconReload,
  IconSearch,
  IconTag,
  IconTrash,
} from "@tabler/icons-react";
import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";

import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiImage,
  EuiLink,
  euiPaletteColorBlindBehindText,
} from "@elastic/eui";
import { modals } from "@mantine/modals";
import {
  IconEdit,
  IconList,
  IconSortAscendingShapes,
  IconTimeDuration15,
} from "@tabler/icons-react";
import BreadCrumb from "../../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { getDataMegaMenu } from "../../../../api/ApiMegaMenu";
import {
  getDataListProduct,
  importExcelImageItem,
  modifyItemStatus,
} from "../../../../api/ApiProduct";
import { syncItemForAdmin } from "../../../../api/ApiProductAds";
import { getDataBrandV2 } from "../../../../api/ApiSell";
import AppAction from "../../../../common/AppAction";
import { formatDateTransfer } from "../../../../common/FormatDate/FormatDate";
import LoadingOverlayCustom from "../../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_URL } from "../../../../config";
import { _localization } from "../../../../config/location";
import { API_ROUTE } from "../../../../const/apiRoute";
import { TblItemCommand } from "../../../../model/ProductList";
import { SelectListItemModel } from "../../../../model/SelectListItem copy";
import HomeViewCategoryV2 from "../../../Category/index2";
import DeleteView from "../DeleteView";
import ModalUpdateExcelProduct from "../ModalUpdate/ModalUpdateExcelProduct";
import UpdateCharacteristicsModal from "../ModalUpdate/UpdateCharacteristicsModal";
import UpdateOrderNumberView from "./updateorderNumberView";
import { DatePickerInput } from "@mantine/dates";
import dayjs from "dayjs";

const ProductListV2 = () => {
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
  const navigate = useNavigate();

  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblItemCommand[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const categoryNameFromUrl = queryParams.get("categoryName");
  const categoryIdFromUrl = queryParams.get("categoryId");

  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [visible, { toggle, close, open }] = useDisclosure(false);

  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 2, xl: 2 };

  // data tất cả dữ liệu thương hiệu sản phẩm
  const [dataBrand, setDataBrand] = useState<any[]>();

  //data thương hiệu sản phẩm
  const [dataBrandOption, setDataBrandOption] = useState<SelectListItemModel[]>(
    []
  );
  // Danh mục sản phẩm
  const [dataCategoryOption, setDataCategoryOption] = useState<
    SelectListItemModel[]
  >([]);
  //   format tiền
  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };

  const [searchValue, setSearchValue] = useState(""); // Giá trị tìm kiếm gốc
  const [debouncedSearchValue] = useDebouncedValue(searchValue, 400);

  const [valueCategory, setValueCategory] = useState<any>(() => {
    if (categoryNameFromUrl && categoryIdFromUrl) {
      return { categoryName: categoryNameFromUrl, id: categoryIdFromUrl };
    }
    return null;
  }); // Giá trị danh mục sản phẩm
  //   search option
  const visColorsBehindText = euiPaletteColorBlindBehindText();
  const searchOption = {
    StatusFilter: [
      {
        value: "1",
        label: "Mới",
        color: visColorsBehindText[0],
      },
      {
        value: "2",
        label: "Hot (hỏi nhiều)",
        color: visColorsBehindText[1],
      },
      {
        value: "3",
        label: "Bán chạy",
        color: visColorsBehindText[2],
      },
      {
        value: "4",
        label: "Xả hàng (sale-off)",
        color: visColorsBehindText[3],
      },
      {
        value: "5",
        label: "Chỉ bán online",
        color: visColorsBehindText[4],
      },
    ],
    searchType: [
      {
        value: "1",
        label: "Giá bán = 0",
        color: visColorsBehindText[0],
      },
      // {
      //   value: "2",
      //   label: "Còn hàng",
      //   color: visColorsBehindText[1],
      // },
      // {
      //   value: "3",
      //   label: "Hết hàng",
      //   color: visColorsBehindText[2],
      // },
      {
        value: "4",
        label: "Có giá thị trường",
        color: visColorsBehindText[3],
      },
      // {
      //   value: "5",
      //   label: "Có khuyến mại",
      //   color: visColorsBehindText[4],
      // },
      // {
      //   value: "6",
      //   label: "Có cấu hình",
      //   color: visColorsBehindText[5],
      // },
      {
        value: "7",
        label: "Có mã kho",
        color: visColorsBehindText[6],
      },
      {
        value: "8",
        label: "Chưa có mã kho",
        color: visColorsBehindText[7],
      },
      {
        value: "9",
        label: "Chưa có ảnh",
        color: visColorsBehindText[8],
      },
      {
        value: "10",
        label: "Chưa có ảnh sản phẩm",
        color: visColorsBehindText[9],
      },
      {
        value: "11",
        label: "Chưa có ảnh khách hàng",
        color: visColorsBehindText[10],
      },
      {
        value: "12",
        label: "Chưa có ảnh Hacom tự chụp",
        color: visColorsBehindText[11],
      },
      {
        value: "13",
        label: "Chưa hiển thị",
        color: visColorsBehindText[12],
      },
      {
        value: "14",
        label: "Đang hiển thị",
        color: visColorsBehindText[13],
      },
      {
        value: "15",
        label: "Chưa có danh mục",
        color: visColorsBehindText[14],
      },
      {
        value: "16",
        label: "Chưa mô tả",
        color: visColorsBehindText[15],
      },
      {
        value: "17",
        label: "Chưa có thông số nhập text",
        color: visColorsBehindText[16],
      },
      {
        value: "18",
        label: "Chưa có mô tả tóm tắt",
        color: visColorsBehindText[17],
      },
    ],
  };

  // đoạn check đặc điểm sản phẩm switchcase trả về label
  const getLabelByValue = (value: string): string => {
    switch (value) {
      case "newStatus":
        return "Mới";
      case "hotStatus":
        return "HOT (hỏi nhiều)";
      case "bestSaleStatus":
        return "Bán chạy";
      case "saleOffStatus":
        return "Xả hàng (sale-off)";
      case "onlineStatus":
        return "Chỉ bán online";
      default:
        return "Không xác định";
    }
  };

  const formSeachInput = useForm<{
    KeySearch: string;
    StatusFilter: string[]; //Đặc điểm sản phẩm
    SearchType: string[]; //lọc theo điều kiện
    SEOType: string[]; //Loại SEO (NoIndex/NoFollow)
    CategoryId: string[]; //danh mục sản phẩm
    BrandId: string[]; //thương hiệu sản phẩm
    FromDate: string | null;
    ToDate: string | null;
    OrderBySTT: string | null; // sắp xếp theo STT
    IsNew: boolean;
    StockStatus: boolean;
  }>({
    mode: "uncontrolled",
    initialValues: {
      KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
      StatusFilter:
        _searchJson && checkedPinSearch ? _searchJson?.StatusFilter : [], //Đặc điểm sản phẩm
      SearchType:
        _searchJson && checkedPinSearch ? _searchJson?.SearchType : [], //lọc theo điều kiện
      SEOType: _searchJson && checkedPinSearch ? _searchJson?.SEOType : [], //Loại SEO
      CategoryId:
        _searchJson && checkedPinSearch ? _searchJson?.CategoryId : [], //danh mục sản phẩm
      BrandId: _searchJson && checkedPinSearch ? _searchJson?.BrandId : [], //thương hiệu sản phẩm
      FromDate: _searchJson && checkedPinSearch ? _searchJson?.FromDate : null,
      ToDate: _searchJson && checkedPinSearch ? _searchJson?.ToDate : null,
      OrderBySTT:
        _searchJson && checkedPinSearch ? _searchJson?.OrderBySTT : null,
      IsNew: _searchJson && checkedPinSearch ? _searchJson?.IsNew : false,
      StockStatus:
        _searchJson && checkedPinSearch ? _searchJson?.StockStatus : false,
    },
  });

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT / ID",
        accessorKey: "STT",
        Cell: ({ row }) => (
          <Box>
            <Text size="sm" fw={600}>
              #{row?.index + 1}
            </Text>
            <Text size="xs" c="dimmed">
              #{row.original.id}
            </Text>
          </Box>
        ),
        size: 80,
      },
      {
        accessorKey: "primaryImage",
        header: "Ảnh sản phẩm",
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue && (
              <EuiImage
                size=""
                width={60}
                height={80}
                src={renderedCellValue?.toString() || ""}
                alt="alt"
              />
            )}
          </>
        ),
        size: 90,
      },
      {
        accessorKey: "itemName",
        header: "Tên Sản Phẩm",
        size: 400,
        Cell: ({ renderedCellValue, row }) => {
          const [clickCount, setClickCount] = React.useState(0);
          const [clickTimer, setClickTimer] =
            React.useState<NodeJS.Timeout | null>(null);

          const handleBadgeClick = () => {
            const newCount = clickCount + 1;
            setClickCount(newCount);

            if (clickTimer) {
              clearTimeout(clickTimer);
            }

            const timer = setTimeout(() => {
              if (newCount === 1) {
                // Single click - copy mã sản phẩm
                navigator.clipboard.writeText(row.original.itemCode);
                NotificationExtension.Success("Đã copy mã sản phẩm!");
              } else if (newCount >= 2) {
                // Double click - mở detail
                editItem(
                  row.original.id,
                  "detail",
                  row.original.itemName,
                  false
                );
              }
              setClickCount(0);
            }, 300);

            setClickTimer(timer);
          };

          return (
            <Box>
              <div
                style={{
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  wordBreak: "break-word",
                  lineHeight: "1.4",
                  maxWidth: "380px",
                  padding: "4px 0",
                  marginBottom: "8px",
                }}
              >
                {renderedCellValue}
              </div>
              <Flex gap={5} align="center" wrap="wrap">
                <Badge
                  variant="dot"
                  radius="xs"
                  style={{
                    cursor: "pointer",
                  }}
                  size="md"
                  onClick={handleBadgeClick}
                >
                  {row.original.itemCode}
                </Badge>
                {row.original.brandId && (
                  <Badge size="sm" variant="light" color="blue">
                    {
                      dataBrand?.filter(
                        (item: any) => item?.id === row.original.brandId
                      )[0]?.name
                    }
                  </Badge>
                )}
              </Flex>
            </Box>
          );
        },
      },
      {
        accessorKey: "unitSellingPrice",
        header: "Thông Tin Bán Hàng",
        Cell: ({ row }) => (
          <Box style={{ minWidth: 200 }}>
            <Flex direction="row" gap={4} align="center">
              <Text size="xs" c="dimmed">
                Giá bán:
              </Text>
              <Text size="sm" fw={600} c="red">
                {formatCurrencyVND(row.original.unitSellingPrice)} vnđ
              </Text>
            </Flex>
            <Flex direction="row" gap={4} align="center" mt={4}>
              <Text size="xs" c="dimmed">
                Giá thị trường:
              </Text>
              <Text size="sm" fw={500}>
                {formatCurrencyVND(row.original.marketPrice)}
              </Text>
            </Flex>
            <Flex direction="row" gap={4} align="center" mt={4}>
              <Text size="xs" c="dimmed">
                Bảo hành:
              </Text>
              <Text size="sm" fw={500}>
                {row.original.warrantyDescrition}
              </Text>
            </Flex>
          </Box>
        ),
        size: 250,
      },
      {
        accessorKey: "creationDate",
        header: "Thông Tin Quản Trị",
        Cell: ({ renderedCellValue, row }: any) => (
          <Box>
            <Flex direction="row" gap={4} align="center">
              <Text size="xs" c="dimmed">
                Ngày tạo:
              </Text>
              <Text size="xs">
                {renderedCellValue && formatDateTransfer(renderedCellValue)}
              </Text>
            </Flex>
            {/* <Flex direction="row" gap={4} align="center" mt={4}>
              <Text size="xs" c="dimmed">
                Người tạo:
              </Text>
              <Text size="xs">{row.original.createdBy}</Text>
            </Flex> */}
            <Flex direction="row" gap={4} align="center" mt={4}>
              <Text size="xs" c="dimmed">
                Hoàn thiện:
              </Text>
              <Text size="xs">
                {row.original.finishedDate &&
                  formatDateTransfer(row.original.finishedDate)}
              </Text>
            </Flex>
            <Flex direction="row" gap={4} align="center" mt={4}>
              <Text size="xs" c="dimmed">
                Người HT:
              </Text>
              <Text size="xs">{row.original.finishedBy}</Text>
            </Flex>
            <Flex direction="row" gap={4} align="center" mt={4}>
              <Text size="xs" c="dimmed">
                Cập Nhật:
              </Text>
              <Text size="xs">
                {row.original.lastUpdateDate &&
                  formatDateTransfer(row.original.lastUpdateDate)}
              </Text>
            </Flex>
            <Flex direction="row" gap={4} align="center" mt={4}>
              <Text size="xs" c="dimmed">
                Update:
              </Text>
              <Text size="xs">
                {row.original.lastUpdatedBy === "consumer.web"
                  ? "Hệ thống"
                  : row.original.lastUpdatedBy}
              </Text>
            </Flex>
          </Box>
        ),
        size: 200,
      },
      {
        accessorKey: "orderNumber",
        header: "STT / Trạng thái",
        size: 150,
        Cell: ({ row }) => {
          return (
            <Box>
              <UpdateOrderNumberView
                onSearch={() => fetchData()}
                id={row.original.id}
                orderNumber={row.original.orderNumber ?? 0}
                item={row.original}
              />
              <EuiLink
                target="_blank"
                onClick={(e: any) => {
                  handleEditItemInUse(row.original.id);
                }}
                style={{ marginTop: 8, display: "block" }}
              >
                <Tooltip label="Click để chỉnh sửa trạng thái">
                  <Badge
                    color={row.original.inUse === "Y" ? "blue" : "red"}
                    variant="filled"
                    size="md"
                    style={{ cursor: "pointer" }}
                  >
                    {row.original.inUse === "Y" ? "Hiển thị" : "Ẩn"}
                  </Badge>
                </Tooltip>
              </EuiLink>
            </Box>
          );
        },
      },
      {
        accessorKey: "updateDetails",
        header: "Chi tiết cập nhật",
        size: 150,
        Cell: ({ row }) => {
          const item = row.original;

          const renderDetail = (title: string, user: string | null | undefined, date: string | null | undefined) => {
            const isValidDate = date && date !== "0001-01-01T00:00:00" && date !== "0001-01-01T00:00:00Z";
            const dateStr = isValidDate ? dayjs(date).format("DD/MM/YYYY HH:mm:ss") : "";
            const displayUser = user || "";
            return (
              <Table.Tr>
                <Table.Td style={{ fontWeight: 600, color: "#343a40", padding: "16px", width: "35%" }}>
                  {title}
                </Table.Td>
                <Table.Td style={{ padding: "16px" }}>
                  {displayUser || dateStr ? (
                    <Flex align="center" gap={6} wrap="nowrap">
                      <Text size="sm" c="dimmed" style={{ whiteSpace: "nowrap" }}>Update:</Text>
                      {displayUser && <Text size="sm" fw={600} color="blue" style={{ whiteSpace: "nowrap" }}>{displayUser}</Text>}
                      {displayUser && dateStr && <Text size="sm" c="dimmed" style={{ whiteSpace: "nowrap" }}>-</Text>}
                      {dateStr && <Text size="sm" fw={500} style={{ whiteSpace: "nowrap" }}>{dateStr}</Text>}
                    </Flex>
                  ) : (
                    <Text size="sm" c="dimmed" fs="italic">Chưa có thông tin cập nhật</Text>
                  )}
                </Table.Td>
              </Table.Tr>
            );
          };

          const openDetailModal = () => {
            modals.open({
              title: <Title order={4}>Chi tiết người cập nhật</Title>,
              size: "xl",
              centered: true,
              children: (
                <Box style={{ border: "1px solid #dee2e6", borderRadius: "8px", overflow: "hidden" }}>
                  <Table striped highlightOnHover horizontalSpacing="md" verticalSpacing="sm">
                    <Table.Thead bg="#f8f9fa">
                      <Table.Tr>
                        <Table.Th style={{ fontWeight: 700, color: "#212529", padding: "16px" }}>Trường dữ liệu</Table.Th>
                        <Table.Th style={{ fontWeight: 700, color: "#212529", padding: "16px" }}>Hiển thị</Table.Th>
                      </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                      {renderDetail("Tên sản phẩm", item.itemNameUpdatedBy, item.itemNameUpdatedAt)}
                      {renderDetail("Meta SEO", item.metaTitleUpdatedBy || item.metaDescUpdatedBy || item.metaKeywordUpdatedBy, item.metaTitleUpdatedAt || item.metaDescUpdatedAt || item.metaKeywordUpdatedAt)}
                      {renderDetail("USP sản phẩm", item.itemSummaryUpdatedBy, item.itemSummaryUpdatedAt)}
                      {renderDetail("Mô tả sản phẩm", item.descriptionUpdatedBy, item.descriptionUpdatedAt)}
                      {renderDetail("Thông số kỹ thuật sản phẩm", item.itemSpecUpdatedBy, item.itemSpecUpdatedAt)}
                    </Table.Tbody>
                  </Table>
                </Box>
              ),
            });
          };

          return (
            <Box>
              <Button
                variant="outline"
                size="xs"
                color="blue"
                onClick={openDetailModal}
              >
                Xem chi tiết
              </Button>
            </Box>
          );
        },
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 160,
        Cell: ({ renderedCellValue, row }) => (
          <Flex direction={"column"} gap={7}>
            <EuiFlexGroup
              responsive={true}
              wrap={false}
              gutterSize="s"
              alignItems="center"
              justifyContent="center"
            >
              <EuiFlexItem grow={false}>
                <Tooltip label="Cập nhật đặc điểm sản phẩm">
                  <ActionIcon
                    variant="light"
                    aria-label="Settings"
                    color="violet"
                    onClick={() => handleOpenModal(row.original.id)}
                  >
                    <IconReload size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
              </EuiFlexItem>
              <EuiFlexItem grow={false}>
                <Tooltip label="Chỉnh sửa sản phẩm">
                  <ActionIcon
                    variant="light"
                    aria-label="Settings"
                    color="green"
                    onClick={(e: any) => {
                      editItem(
                        row.original.id,
                        "edit",
                        row.original.itemName,
                        false
                      );
                    }}
                  >
                    <IconEdit />
                  </ActionIcon>
                </Tooltip>
              </EuiFlexItem>
              {/* <EuiFlexItem grow={false}>
                <Tooltip label="Xóa sản phẩm">
                  <ActionIcon
                    variant="light"
                    aria-label="Settings"
                    color="red"
                    onClick={(e: any) => {
                      deleteItem([row.original.id]);
                    }}
                  >
                    <IconTrash />
                  </ActionIcon>
                </Tooltip>
              </EuiFlexItem> */}
              <EuiFlexItem grow={false}>
                <Tooltip label="Mở trang tab">
                  <ActionIcon
                    variant="light"
                    aria-label="Settings"
                    color="blue"
                    onClick={(e: any) => {
                      const productData = {
                        id: row.original.id,
                        type: "edit",
                        itemCode: row.original.itemName,
                        timestamp: new Date().getTime(),
                      };
                      localStorage.setItem(
                        "hacom_edit_product",
                        JSON.stringify(productData)
                      );
                      window.open("/product-manager/product-list", "_blank");
                    }}
                  >
                    <IconExternalLink size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
              </EuiFlexItem>
            </EuiFlexGroup>
            <Anchor
              href={`${hacomUrl}/${row.original.url}`}
              underline="always"
              target="_blank"
            >
              Xem tại web
            </Anchor>
          </Flex>
        ),
      },
    ],
    [dataBrand, data]
  );
  //Hàm xóa sản phẩm
  const deleteItem = (idItem: number[]) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa sản phẩm</Title>
        </>
      ),
      children: (
        <DeleteView onSearch={() => () => fetchData()} idItem={idItem} />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  // Hàm kiểm tra
  // const handleEditData = async (id: number) => {
  //   if (id) {
  //     editItem(id, type);
  //   } else {
  //     NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
  //   }
  // };
  // Hàm mở modal chỉnh sửa sản phẩm
  const editItem = (
    id: number,
    type: string,
    itemName: string,
    openInNewTab: boolean = false
  ) => {
    // Kiểm tra localStorage trước
    let tabParam = null;
    try {
      const storedData = localStorage.getItem("hacom_edit_product");
      if (storedData) {
        const productData = JSON.parse(storedData);
        if (productData.tab && productData.id === id) {
          tabParam = productData.tab;
        }
      }
    } catch (error) {
      console.error("Error reading tab from localStorage:", error);
    }

    // Nếu không có trong localStorage, thử lấy từ URL
    if (!tabParam) {
      const queryParams = new URLSearchParams(location.search);
      tabParam = queryParams.get("tab");
    }
    const productItem = data.find((item) => item.id === id);
    const productName = productItem ? productItem.itemName : itemName;

    navigate(`/product-manager/edit-product/${id}`, {
      state: {
        type: type,
        itemCode: productName ? productName : "",
        initialTab: tabParam ? tabParam : undefined,
      },
    });
  };

  // Hàm mở modal edit đặc điểm sản phẩm
  const handleOpenModal = (id: number) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Cập nhật đặc điểm sản phẩm</Title>
        </>
      ),
      children: (
        <UpdateCharacteristicsModal
          data={data}
          IdSp={id}
          fetchData={fetchData}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  // Hàm xử lý chỉnh sửa trạng thái sản phẩm
  const handleEditItemInUse = async (id: number) => {
    await modifyItemStatus(id);
    fetchData();
  };

  // // Hàm xử lý cập nhật orderNumber
  // const handleUpdateOrderNumber = async (id: number, orderNumber: number) => {
  //   modals.openConfirmModal({
  //     title: (
  //       <>
  //         <div color="white">
  //           <Title order={5}>Cập nhật thứ tự hiển thị</Title>
  //         </div>
  //       </>
  //     ),
  //     children:(
  //       <UpdateOrderNumberView
  //       orderNumber={orderNumber}
  //       id={id}
  //       onSearch={fetchData}
  //       />
  //     ),
  //   })
  // };

  const [file, setFile] = useState<File | null>(null);

  useEffect(() => {
    if (file) {
      if (
        file &&
        (file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          file.type === "application/vnd.ms-excel")
      )
        uploadFile(file);
      else NotificationExtension.Fails("File không đúng định đạng Excel !");
    }
  }, [file]);

  const uploadFile = async (e: File) => {
    if (!e) {
      NotificationExtension.Fails("File rỗng hoặc chưa chọn file !");
      return;
    }
    open();
    // await new Promise((resolve) => setTimeout(resolve, 2000));
    const formData = new FormData();
    formData.append("FormFile", e);

    const resSaveFile = await importExcelImageItem(formData);
    if (resSaveFile && resSaveFile.success) {
      setFile(null);
      NotificationExtension.Success("Import file thành công!");
      setTimeout(() => {
        fetchData();
      }, 1000);
    } else {
      NotificationExtension.Fails("Import file thất bại !");
      setFile(null);
    }

    close();
  };

  const getFileSampleImage = async () => {
    open();
    try {
      await fetch(`${BASE_API_URL}/${API_ROUTE.GET_SAMPLE_IMAGE}`, {
        method: "GET",
      })
        .then((response) => {
          if (response.ok) {
            return response.blob();
          } else {
            throw new Error("Failed to fetch the resource");
          }
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          let filename = "File_anh_mau.xlsx";
          const link = document.createElement("a");
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          NotificationExtension.Success("Lấy file ảnh mẫu thành công !");
        })
        .catch((error) => {
          console.error("Error:", error);
          NotificationExtension.Fails("Lấy file ảnh mẫu thất bại !");
        });
    } catch (error) {
      console.log("Error downloading template:", error);
      NotificationExtension.Fails("Tải file mẫu thất bại");
    } finally {
      close(); // Đóng loading overlay sau khi tải xong
    }
  };

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "itemCode", "id"],
        right: ["action"],
      },
      // columnVisibility: { id: true },
      density: "xs",
    },
    enableStickyFooter: false,
    enableRowSelection: false,
    enableToolbarInternalActions: false,
    mantineTableContainerProps: {
      style: {
        // maxHeight: height, // Xóa hoặc comment dòng này
        // minHeight: height, // Xóa hoặc comment dòng này
        // height: "100vh",
        overflowY: "visible", // Thêm dòng này để tắt thanh cuộn dọc của bảng
      },
    },
    enableStickyHeader: false,
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: 550,
        fontSize: "12px",
        padding: "6px 8px",
      },
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  //lấy data list sp
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    try {
      let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${pagination.pageSize
        }`;
      const search = formSeachInput.getValues();
      const keySearchObj = {
        KeySearch: search.KeySearch?.trim().toLowerCase() || "",
        StatusFilter: search.StatusFilter || [], //chưa có trường tryền vào để lọc thuộc tính
        SearchType: search.SearchType || [],
        BrandId: search.BrandId || [],
        CategoryId: search.CategoryId || [],
        SEOType: search.SEOType || [],
        FromDate: search.FromDate || null,
        ToDate: search.ToDate || null,
        OrderBySTT: search.OrderBySTT === "true" ? true : false, // sắp xếp theo STT
        IsNew: search.IsNew,
        StockStatus: search.StockStatus,
      };
      // Xây dựng URL từ keySearchObj
      Object.entries(keySearchObj).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            url += `&${key}=${encodeURIComponent(item)}`;
          });
        } else if (value) {
          url += `&${key}=${encodeURIComponent(value)}`;
        }
      });
      let response = await getDataListProduct(url);
      if (response && response.success) {
        setData(response.data);
        setRowCount(response.totalCount);
      }
      table.resetRowSelection();
    } catch (error: any) {
      setData([]);
      return null;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...formSeachInput.getValues(),
          pageSize: pagination.pageSize,
          pageIndex: pagination.pageIndex,
        })
      );
    }
  };

  const handleSyncItemForAdmin = async () => {
    open();
    try {
      const res = await syncItemForAdmin();

      if (res && res.success) {
        close();
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  //   Lấy data thương hiệu sản phẩm
  const fetchDataBrand = async (keySearch?: string) => {
    try {
      let url = "?Skip=0&Take=1000";
      if (keySearch) {
        url += `&KeySearch=${keySearch}`;
      }
      const response = await getDataBrandV2(url);
      if (response && response.data.lists) {
        const formattedData = response.data.lists
          .filter((i: any) => i.id && i.name)
          .map((item: any, index: number) => ({
            value: item.id.toString(),
            label: item.name,
          }));
        setDataBrand(response.data.lists);
        setDataBrandOption(formattedData);
      }
    } catch (error) {
      console.log("error fetchDataBrand", error);
    }
  };

  // Lấy data danh mục sản phẩm
  const fetchDataCategory = async (keysearch?: string) => {
    try {
      let url = `?Skip=0&Take=1000`;
      if (keysearch && Array.isArray(keysearch) && keysearch.length > 0) {
        url += keysearch.map((item) => `&CategoryIds=${item}`).join("");
      }
      let callapi = await getDataMegaMenu(url);
      if (callapi && callapi.data.lists) {
        const formattedData = callapi.data.lists
          .filter((i: any) => i.categoryName && i.id)
          // Chỉ lấy đúng danh mục được chọn, không lấy danh mục con
          .filter((i: any) => {
            if (!keysearch || keysearch.length === 0) return true;
            return keysearch.includes(i.id.toString());
          })
          .map((item: any) => ({
            value: item.id.toString(),
            label: item.categoryName,
          }));
        setDataCategoryOption(formattedData);
      }
    } catch (error: any) {
      console.log("error fetchDataCategory", error);
    }
  };

  // Export excel
  const exportExcel = async (keyWord?: string, inActive?: boolean) => {
    try {
      open();
      const baseUrl = `${BASE_API_URL}/ExportExcel/export-danh-sach-san-pham`;
      const params = new URLSearchParams();
      const search = formSeachInput.getValues();
      const keySearchObj = {
        KeySearch: search.KeySearch?.trim().toLowerCase() || "",
        StatusFilter: search.StatusFilter || [],
        SearchType: search.SearchType || [],
        BrandId: search.BrandId || [],
        CategoryId: search.CategoryId || [],
        SEOType: search.SEOType || [],
        FromDate: search.FromDate || null,
        ToDate: search.ToDate || null,
        IsNew: search.IsNew,
        StockStatus: search.StockStatus,
      };
      Object.entries(keySearchObj).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, String(item));
          });
        } else if (value) {
          params.append(key, String(value));
        }
      });

      const fullUrl = params.toString()
        ? `${baseUrl}?${params.toString()}`
        : baseUrl;

      await fetch(fullUrl, {
        method: "GET",
      })
        .then((response) => {
          if (response.ok) {
            return response.blob();
          } else {
            throw new Error("Failed to fetch the resource");
          }
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          let filename = "Danh_sach_san_pham.xlsx";
          const link = document.createElement("a");
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          NotificationExtension.Success("Export excel thành công !");
        })
        .catch((error) => {
          console.error("Error:", error);
          NotificationExtension.Fails("Export excel thất bại !");
        });
    } catch (error) {
      NotificationExtension.Fails("Export excel thất bại !");
    } finally {
      close();
    }
  };

  // Export EXCEL SP SEO
  const handleExportExcelSPSEO = async (
    keyWord?: string,
    inActive?: boolean
  ) => {
    try {
      open();
      const baseUrl = `${BASE_API_URL}/ExportExcel/export-danh-sach-san-pham-seo`;
      const params = new URLSearchParams();
      const search = formSeachInput.getValues();
      const keySearchObj = {
        KeySearch: search.KeySearch?.trim().toLowerCase() || "",
        StatusFilter: search.StatusFilter || [],
        SearchType: search.SearchType || [],
        BrandId: search.BrandId || [],
        CategoryId: search.CategoryId || [],
        SEOType: search.SEOType || [],
        FromDate: search.FromDate || null,
        ToDate: search.ToDate || null,
        IsNew: search.IsNew,
        StockStatus: search.StockStatus,
      };
      Object.entries(keySearchObj).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, String(item));
          });
        } else if (value) {
          params.append(key, String(value));
        }
      });

      const fullUrl = params.toString()
        ? `${baseUrl}?${params.toString()}`
        : baseUrl;

      await fetch(fullUrl, {
        method: "GET",
      })
        .then((response) => {
          if (response.ok) {
            return response.blob();
          } else {
            throw new Error("Failed to fetch the resource");
          }
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          let filename = "Danh_sach_san_pham_seo.xlsx";
          const link = document.createElement("a");
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          NotificationExtension.Success("Export excel thành công !");
        })
        .catch((error) => {
          console.error("Error:", error);
          NotificationExtension.Fails("Export excel thất bại !");
        });
    } catch (error) {
      NotificationExtension.Fails("Export excel thất bại !");
    } finally {
      close();
    }
  };
  // Gọi API khi giá trị debounce thay đổi
  useEffect(() => {
    if (debouncedSearchValue) {
      fetchDataBrand(debouncedSearchValue);
    }
  }, [debouncedSearchValue]);

  useEffect(() => {
    fetchDataBrand();
  }, []);

  // Khi `valueCategory` thay đổi, cập nhật URL

  useEffect(() => {
    if (valueCategory && valueCategory.length > 0) {
      // const newCategoryName = valueCategory.categoryName;
      // const newCategoryID = valueCategory.id;
      // navigate(
      //   `/product-manager/product-list?categoryName=${encodeURIComponent(
      //     newCategoryName
      //   )}&categoryId=${newCategoryID}`
      // );
      const fetchCategoryData = async () => {
        await fetchDataCategory(valueCategory);
        if (valueCategory) {
          formSeachInput.setFieldValue("CategoryId", valueCategory);
        } else {
          formSeachInput.setFieldValue("CategoryId", []);
        }
      };
      const run = async () => {
        await fetchCategoryData();
        await fetchData();
      };
      run();
    }
  }, [valueCategory]);

  //  useEffect(() => {
  //   if (categoryNameFromUrl && !valueCategory) {
  //     setValueCategory({
  //       categoryName: categoryNameFromUrl,
  //       id: categoryIdFromUrl,
  //     });
  //   }
  // }, [categoryNameFromUrl]);

  useEffect(() => {
    fetchData();
  }, [pagination]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (170 + headerHeight));
      // setHeight(window.innerHeight - (-300 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  //  hàm xử lý thay đổi của chi nhánh giá trị tìm kiếm
  const renderMultiSelectOptionBrandId: MultiSelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Flex direction={"row"} gap="sm" align="center" justify={"start"}>
      {checked && <IconCheck size={12} color="gray" />}
      <Text size="sm">
        {dataBrandOption.find((x: any) => x.value === option.value)?.label}
      </Text>
    </Flex>
  );

  // Hàm xử lý thay đổi của danh mục sản phẩm
  // const renderMultiSelectOptionCategoryId: MultiSelectProps["renderOption"] = ({
  //   option,
  //   checked,
  // }) => (
  //   <Flex direction={"row"} gap="sm" align="center" justify={"start"}>
  //     {checked && <IconCheck size={12} color="gray" />}
  //     <Text size="sm">
  //       {
  //         dataCategoryOption.find(
  //           (x: any) =>
  //             x.value.toString() === valueCategory?.categoryCode?.toString()
  //         )?.label
  //       }
  //     </Text>
  //   </Flex>
  // );
  // Hàm xử lý đặc điểm sản phẩm
  const renderMultiSelectOptionAttribute: MultiSelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Flex direction={"row"} gap="sm" align="center" justify={"start"}>
      {checked && <IconCheck size={12} color="gray" />}
      <Text>
        {
          searchOption?.StatusFilter?.find((x: any) => x.value === option.value)
            ?.label
        }
      </Text>
    </Flex>
  );

  // hàm mở modal để cập nhật file excel
  const openModalupdateExel = () => {
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Cập nhật sản phẩm qua Excel</Title>
          </div>
        </>
      ),
      children: <ModalUpdateExcelProduct location={location} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  // hàm mở modal để cập nhật file excel
  const openModalupdatePriceProductExel = () => {
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Cập nhật giá sản phẩm qua Excel</Title>
          </div>
        </>
      ),
      children: (
        <ModalUpdateExcelProduct
          location={location}
          typeImport="productPrice"
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleOpenModalCategory = () => {
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Chọn danh mục để xem</Title>
          </div>
        </>
      ),
      children: (
        <BrowserRouter>
          <HomeViewCategoryV2
            isModal={true}
            setValueCategory={setValueCategory}
          />
        </BrowserRouter>
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  // Xử lý khi URL có tham số để mở modal editItem
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const openEdit = queryParams.get("openEdit");
    const idParam = queryParams.get("id");
    const tabParam = queryParams.get("tab");
    const itemCodeParam = queryParams.get("itemCode");
    const itemNameParam = queryParams.get("itemName");
    const typeParam = queryParams.get("type") || "edit";

    if (openEdit === "true" && idParam) {
      // Mở modal chỉnh sửa sản phẩm với tham số từ URL (fullScreen = true cho tab mới)
      editItem(
        parseInt(idParam),
        typeParam,
        itemCodeParam || "", // itemCode bây giờ có thể chứa tên sản phẩm
        true
      );

      // Clear URL params after handling, but add a small delay
      setTimeout(() => {
        console.log("Clearing URL parameters");
        navigate("/product-manager/product-list", { replace: true });
      }, 500); // Give time for the modal to open
    }
  }, [location.search, navigate, editItem]);

  useEffect(() => {
    const directQueryParams = new URLSearchParams(window.location.search);
    const directOpenEdit = directQueryParams.get("openEdit");
    const directIdParam = directQueryParams.get("id");
    const directTabParam = directQueryParams.get("tab");
    const directItemCodeParam = directQueryParams.get("itemCode");
    const directItemNameParam = directQueryParams.get("itemName");
    const directTypeParam = directQueryParams.get("type") || "edit";
    if (directOpenEdit === "true" && directIdParam) {
      setTimeout(() => {
        editItem(
          parseInt(directIdParam),
          directTypeParam,
          directItemCodeParam || "", // itemCode bây giờ có thể chứa tên sản phẩm
          true // fullScreen = true cho direct URL access
        );

        // Clean URL but keep the page path
        if (window.history && window.history.replaceState) {
          const cleanUrl = window.location.pathname;
          window.history.replaceState({}, document.title, cleanUrl);
        }
      }, 300);
    }
  }, []); // Empty dependency array - runs only once on mount

  useEffect(() => {
    try {
      // Retrieve data from localStorage
      const storedData = localStorage.getItem("hacom_edit_product");
      if (storedData) {
        const productData = JSON.parse(storedData);
        const currentTime = new Date().getTime();
        const dataTime = productData.timestamp || 0;

        if (currentTime - dataTime < 300000) {
          if (productData.id) {
            editItem(
              parseInt(productData.id),
              productData.type || "edit",
              productData.itemCode || "", // itemCode bây giờ chứa tên sản phẩm
              true // fullScreen = true cho localStorage (từ tab mới)
            );
            localStorage.removeItem("hacom_edit_product");
          }
        } else {
          localStorage.removeItem("hacom_edit_product");
        }
      }
    } catch (error) {
      console.error("Error processing localStorage data:", error);
      localStorage.removeItem("hacom_edit_product");
    }
  }, []);

  useEffect(() => {
    if (_searchJson) {
      setPagination({
        pageIndex: _searchJson.pageIndex,
        pageSize: _searchJson.pageSize,
      });
    }
  }, []);

  return (
    <Box pos={"relative"}>
      <LoadingOverlayCustom visible={visible} />
      <Flex
        gap="md"
        justify={"space-between"}
        align="center"
        direction="row"
        wrap="wrap"
        w={"100%"}
      >
        <BreadCrumb></BreadCrumb>
        <Flex direction={"row"} gap="md" align="center">
          <Menu>
            <Menu.Target>
              <Button
                leftSection={
                  <IconPhoto style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Import ảnh sản phẩm
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item>
                <Button
                  leftSection={
                    <IconPhotoDown
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                  onClick={() => getFileSampleImage()}
                >
                  Lấy File mẫu import ảnh sản phẩm
                </Button>
              </Menu.Item>
              <Menu.Item>
                <FileButton onChange={setFile}>
                  {(props) => (
                    <Button
                      leftSection={
                        <IconPhotoPlus
                          style={{ width: rem(14), height: rem(14) }}
                        />
                      }
                      w={"100%"}
                      {...props}
                    >
                      Import ảnh sản phẩm
                    </Button>
                  )}
                </FileButton>
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
          <Button
            leftSection={<IconRefresh size={14} />}
            onClick={() => handleSyncItemForAdmin()}
          >
            Đồng bộ sản phẩm
          </Button>
          <AppAction
            // openModal={openModal}
            // openModalDelete={openModalDelete}
            // openModalEdit={openModalEdit}
            isUpdateSearchItem={true}
            openModalupdateExel={openModalupdateExel}
            openExportExcel={exportExcel}
          ></AppAction>
          <Button
            leftSection={<IconFileExport size={14} />}
            onClick={() => handleExportExcelSPSEO()}
          >
            Export DSSP SEO
          </Button>
          {/* <Button
            onClick={() => {
              openModalupdatePriceProductExel();
            }}
            leftSection={<IconFilePlus size={16} />}
            color="blue"
            variant="outline"
          >
            Import giá sản phẩm
          </Button> */}
        </Flex>
      </Flex>

      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "10px 10px",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
        ref={headerRef}
      >
        {/* Thông báo thời gian đồng bộ dữ liệu lên web */}
        <Box
          style={{
            background: "#fffbe6",
            border: "1.5px solid #ffe58f",
            borderRadius: 8,
            padding: "5px",
            marginBottom: 2,
            display: "flex",
            alignItems: "center",
            gap: 10,
            fontWeight: 600,
            color: "#ad6800",
            fontSize: 14,
          }}
        >
          <IconTimeDuration15
            size={22}
            color="#faad14"
            style={{ marginRight: 6 }}
          />
          <span>
            <b>Lưu ý:</b> Sau khi cập nhật,có thể dữ liệu sẽ được đồng bộ lên
            website trong khoảng <b>15-30 phút</b>. Vui lòng kiểm tra lại sau
            thời gian này để thấy thay đổi.
          </span>
        </Box>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <Grid style={{ width: "100%" }} mt={10}>
            <Grid.Col span={sizeGrid}>
              <TextInput
                width="100%"
                placeholder="Từ khoá"
                type="text"
                leftSection={<IconSearch color="#15aabf" />}
                key={formSeachInput.key("KeySearch")}
                {...formSeachInput.getInputProps("KeySearch")}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchData();
                  }
                }}
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <MultiSelect
                searchable
                clearable
                placeholder="Đặc điểm sản phẩm"
                leftSection={<IconTag color="#15aabf" />}
                data={searchOption.StatusFilter || []}
                renderOption={renderMultiSelectOptionAttribute}
                key={formSeachInput.key("StatusFilter")}
                {...formSeachInput.getInputProps("StatusFilter")}
                classNames={{
                  dropdown: "custom-multiselect-dropdown",
                }}
                maxDropdownHeight={700}
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <MultiSelect
                searchable
                clearable
                placeholder="Xét theo điều kiện"
                leftSection={<IconFilter color="#15aabf" />}
                data={searchOption.searchType || []}
                key={formSeachInput.key("SearchType")}
                {...formSeachInput.getInputProps("SearchType")}
                classNames={{
                  dropdown: "custom-multiselect-dropdown",
                }}
                maxDropdownHeight={700}
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <MultiSelect
                key={formSeachInput.key("CategoryId")}
                placeholder="Danh mục sản phẩm"
                searchable
                clearable
                data={dataCategoryOption || []}
                // renderOption={renderMultiSelectOptionCategoryId}
                leftSection={<IconList size={20} color="#15aabf" />}
                {...formSeachInput.getInputProps("CategoryId")}
                onClick={handleOpenModalCategory}
                onChange={(selectedValues) => {
                  if (selectedValues.length === 0) {
                    // Nếu không có danh mục nào được chọn, xóa params khỏi URL
                    navigate("/product-manager/product-list");
                    formSeachInput.setFieldValue("CategoryId", []);
                    setValueCategory(null); // Xóa giá trị danh mục
                    setTimeout(async () => {
                      await fetchData();
                    });
                  }
                }}
                classNames={{
                  dropdown: "custom-multiselect-dropdown",
                }}
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <MultiSelect
                placeholder="Xem theo thương hiệu"
                searchable
                clearable
                data={dataBrandOption || []}
                renderOption={renderMultiSelectOptionBrandId}
                leftSection={<IconBuilding size={20} color="#15aabf" />}
                onClick={() => {
                  if (dataBrandOption.length === 0) {
                    fetchDataBrand();
                  }
                }}
                onSearchChange={(value) => {
                  setSearchValue(value); // Cập nhật giá trị tìm kiếm gốc
                }}
                key={formSeachInput.key("BrandId")}
                {...formSeachInput.getInputProps("BrandId")}
                classNames={{
                  dropdown: "custom-multiselect-dropdown",
                }}
                maxDropdownHeight={700}
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <Select
                searchable
                clearable
                placeholder="Sắp xếp theo thứ tự hiển thị SP"
                leftSection={<IconSortAscendingShapes color="#15aabf" />}
                data={[
                  {
                    value: "true",
                    label: "STT hiển thị tăng dần",
                  },
                  {
                    value: "false",
                    label: "STT hiển thị giảm dần",
                  },
                ]}
                key={formSeachInput.key("OrderBySTT")}
                {...formSeachInput.getInputProps("OrderBySTT")}
                classNames={{
                  dropdown: "custom-multiselect-dropdown",
                }}
                maxDropdownHeight={700}
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <MultiSelect
                placeholder="Loại"
                leftSection={<IconListLetters color="#15aabf" />}
                data={[
                  { label: "NoIndex", value: "19" },
                  { label: "NoFollow", value: "20" },
                ]}
                key={formSeachInput.key("SEOType")}
                {...formSeachInput.getInputProps("SEOType")}
                classNames={{
                  dropdown: "custom-multiselect-dropdown",
                }}
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <DatePickerInput

                placeholder="Chọn ngày bắt đầu"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                key={formSeachInput.key("FromDate")}
                {...formSeachInput.getInputProps("FromDate")}
                value={
                  formSeachInput.getValues().FromDate
                    ? dayjs(formSeachInput.getValues().FromDate).toDate()
                    : null // Nếu không có giá trị, đặt null
                }
                onChange={(date) =>
                  formSeachInput.setFieldValue(
                    "FromDate",
                    date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""
                  )
                }
                clearable
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <DatePickerInput

                placeholder="Chọn ngày kết thúc"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                key={formSeachInput.key("ToDate")}
                {...formSeachInput.getInputProps("ToDate")}
                value={
                  formSeachInput.getValues().ToDate
                    ? dayjs(formSeachInput.getValues().ToDate).toDate()
                    : null
                }
                onChange={(date) =>
                  formSeachInput.setFieldValue(
                    "ToDate",
                    date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""
                  )
                }
                clearable
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <Select
                placeholder="Trạng thái hàng"
                data={[
                  { label: "Còn hàng", value: "true" },
                  { label: "Hết hàng", value: "false" },
                ]}
                key={formSeachInput.key("StockStatus")}
                clearable
                leftSection={<IconBoxSeam size={20} color="#15aabf" />}
                {...formSeachInput.getInputProps("StockStatus")}
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <Flex justify={"center"} align={"center"} h={"100%"}>
                <Switch
                  checked={formSeachInput.getValues()?.IsNew}
                  label={"Sản phẩm mới"}
                  onChange={() =>
                    formSeachInput.setValues((prev) => ({
                      ...prev,
                      IsNew: !formSeachInput.getValues()?.IsNew,
                    }))
                  }
                />
              </Flex>
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <Button
                type="submit"
                leftSection={<IconSearch size={20} />}
                color="blue"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </Box>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default ProductListV2;
